export const FACEBOOK = 'https://www.facebook.com/operabase/';
export const LINKEDIN = 'https://www.linkedin.com/company/operabase-global/about/';
export const TWITTER = 'https://twitter.com/BaseOpera';
export const INSTAGRAM = 'https://www.instagram.com/operabaseglobal/';
export const CONTACT_EMAIL = 'contact@operabase.info';
export const MALTE_CONTACT_EMAIL = 'malte@operabase.com';

export const socialTypes = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  INSTAGRAM: 'instagram',
  LINKEDIN: 'linkedin',
  YOUTUBE: 'youtube',
  VK: 'vk',
  VIMEO: 'vimeo',
};

export const SOCIAL_LINKS = [
  { link: FACEBOOK, type: socialTypes.FACEBOOK },
  { link: TWITTER, type: socialTypes.TWITTER },
  { link: INSTAGRAM, type: socialTypes.INSTAGRAM },
  { link: LINKEDIN, type: socialTypes.LINKEDIN },
];

export const ARTIST_TYPE_ID = 1;
export const AGENT_TYPE_ID = 2;
export const AOS_TYPE_ID = 3;

export const SINGER_PROFESSION_TYPE_ID = 1;
export const INSTRUMENTALIST_PROFESSION_TYPE_ID = 3;
export const ORCHESTRA_PROFESSION_TYPE_ID = 23;
export const CHOIR_PROFESSION_TYPE_ID = 24;

export const LISTING_PAGE = 'listingPage';

export const PRODUCTION_MODE = process.env.NODE_ENV === 'production';

export const contactsIdentifiers = {
  phone: 0,
  email: 1,
  sns: 2,
  website: 3,
  address: 4,
  other: 5,
};

export const repertoireStatuses = {
  RETIRED: 'retire',
  WISHLIST: 'future',
  PAST: 'past',
};

export const performancesAddedByIdentifiers = {
  ADMIN: 'admin',
  COMPANY: 'company',
  ARTIST: 'artist',
  UNKNOWN: 'unknown',
  FESTIVAL: 'festival',
};

export const PRODUCTION_ADDED_IDENTIFIERS_IDS = {
  UNKNOWN: 1,
  ADMIN: 2,
  COMPANY: 3,
  ARTIST: 4,
  AGENCY: 5,
  FESTIVAL: 6,
};

export const langs = {
  EN: 'en',
  BG: 'bg',
  DA: 'da',
  ES: 'es',
  FI: 'fi',
  HU: 'hu',
  LT: 'lt',
  NL: 'nl',
  PT: 'pt',
  SK: 'sk',
  CA: 'ca',
  DE: 'de',
  ET: 'et',
  FR: 'fr',
  IS: 'is',
  LV: 'lv',
  NO: 'no',
  RO: 'ro',
  SL: 'sl',
  CS: 'cs',
  EL: 'el',
  EU: 'eu',
  GA: 'ga',
  IT: 'it',
  MT: 'mt',
  PL: 'pl',
  RU: 'ru',
  SV: 'sv',
};

export const performancesAggregationTypes = {
  profileAgg: 'profile_id',
  profileTypeAgg: 'profile_type_id',
  professionAgg: 'profession_id',
  professionQualificationAgg: 'profession_qualification_id',
  workAgg: 'work_id',
  workRoleAgg: 'work_role_id',
  countryAgg: 'country_id',
  companyAgg: 'company_id',
  composerAgg: 'composer_id',
  productionAgg: 'production_id',
  workTypeAgg: 'work_type_id',
  agencyAgg: 'agency_id',
  yearAgg: 'year_id',
  labelAgg: 'label_id',
  seasonAgg: 'season_id',
  festivalAgg: 'festival_id',
  venueAgg: 'venue_id',
  queryAgg: 'aggregation_query',
  typeAgg: 'aggregation_type',
  regionAgg: 'region_id',
  crewProfileRefAgg: 'crew_profile_reference',
};

export const ARTICLE_AGGREGATION_TYPES = {
  YEAR: 'year',
  TITLE: 'work_id',
  COMPANY: 'company',
};

export const RENTALS_AGGREGATION_TYPES = {
  PRODUCTION_NAME: 'production_name',
  PRODUCTION_TEAM: 'production_team',
  COMPANY: 'company',
  SORT: 'sort',
};

export const STATISTICS_AGGREGATION_TYPES = {
  YEAR: 'year',
  COUNTRY: 'country_id',
  TYPE: 'type_id',
  SEASON: 'season_id',
};

export const COMPETITIONS_AGGREGATION_TYPES = {
  COMPETITION: 'competition_id',
  COUNTRY: 'country_id',
  CITY: 'city',
  STATUS: 'status',
  AGE_LIMIT_MEN: 'age_limit_men',
  AGE_LIMIT_WOMEN: 'age_limit_women',
};

export const dateFormats = {
  basic: 'YYYY-MM-DD',
  productionMonth: "MMM'YY",
  shortTextMonthAndFullYear: 'MMM YYYY',
  year: 'YYYY',
  date: 'DD',
  dayOfWeekShort: 'ddd',
  event: 'DD MMMM YYYY',
  shortMonthEvent: 'DD MMM YYYY',
  shortTextMonthAndYear: 'MMM YY',
};

export const PERFORMANCE_TYPES_ID = {
  WORLD_PREMIERE: 1,
  NATIONAL_PREMIERE: 2,
  CONCERT: 3,
  NEW_PRODUCTION: 4,
  CANCELLED: 5,
  TOUR: 6,
  FESTIVAL: 7,
  MATINEE: 8,
  DOUBLE_BILL: 9,
  RECITAL: 10,
  LIVESTREAM: 11,
  VIDEO_ON_DEMAND: 12,
};

// Translations prefix
export const TP = 'operabase.general';
export const setTranslation = key => `${TP}.${key}`;

export const CALENDAR_VIEW = 'calendar';
export const LIST_VIEW = 'list';

export const workTypes = [
  {
    id: 1,
    slug: 'O',
    name: 'Oratorio/ Orchestral',
  },
  {
    id: 2,
    slug: 'W',
    name: 'Opera',
  },
  {
    id: 3,
    slug: 'L',
    name: 'Operetta',
  },
  {
    id: 4,
    slug: 'Z',
    name: 'Zarzuella',
  },
  {
    id: 5,
    slug: 'T',
    name: 'Music-theatre',
  },
  {
    id: 6,
    slug: 'P',
    name: 'Derived',
  },
  {
    id: 7,
    slug: 'V',
    name: 'Vocal/ Song cycle',
  },
  {
    id: 8,
    slug: 'M',
    name: 'Musical',
  },
];

export const PROFESSIONS_IDS = {
  CONDUCTOR: 4,
  STAGE_DIRECTOR: 2,
};

export const EMPTY_INFO_MARK = '--';

export const MISSING_PRODUCTION_ITEMS_IDS = {
  WORK_NAME: 1,
  COMPANY_NAME: 2,
  CASTS: 3,
  DATES: 4,
};

export const MISSING_PRODUCTION_REQUIRED_ITEMS_IDS = {
  WORK_NAME: MISSING_PRODUCTION_ITEMS_IDS.WORK_NAME,
};

export const PRIVACY_ATTRIBUTE_IDS = {
  PRIVATE: 1,
  PUBLIC: 2,
  PRO: 3,
  FREE_AND_PRO: 4,
};

//  change after api is ready, add keys
export const missingItemsLabels = {
  [MISSING_PRODUCTION_ITEMS_IDS.COMPANY_NAME]: 'SEARCH_COMPANY',
  [MISSING_PRODUCTION_ITEMS_IDS.CASTS]: 'm_CAST',
  [MISSING_PRODUCTION_ITEMS_IDS.WORK_NAME]: 'm_MUSICALWORK',
  [MISSING_PRODUCTION_ITEMS_IDS.DATES]: 'm_DATES',
};

export const PROFESSIONS_AVAILABILITY = {
  CREATE_PROFILE: 'create_profile',
  UPDATE_PROFILE: 'update_profile',
  GET_PROFILE: 'get_profile',
  CREATE_PRODUCTION: 'create_production',
  UPDATE_PRODUCTION: 'update_production',
  GET_PRODUCTION: 'get_production',
  CASTING_TOOL: 'casting_tool',
  CREATE_CREW_PROFILE: 'create_crew_profile',
};

export const PAGINATION_DEFAULT_LIMIT = 10;

const baseUrl = extensions =>
  new RegExp(`^(http://www.|https://www.|http://|https://)?.+\\.(?:${extensions})(\\?)?(.*)?$`);

export const urlRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-\\.]{1}[a-z0-9]+)*\.[a-z]*(:[0-9]{1,5})?(\/.*)?$/;
export const noUrlRegex = /^((?![(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)).)*$/s;
export const imageUrlRegex = baseUrl('png|jpg|jpeg|gif|png');
export const filesUrlRegex = baseUrl('txt|pdf');
export const yearRegex = /(\d{4}|\d{4}-\d{4})$/g;

export const MEDIA_TYPES_IDS = {
  IMAGE: 1,
  VIDEO: 2,
  AUDIO: 3,
};

export const MEDIA_TAGS_TYPES_IDS = {
  PROFILE: 1,
  COMPANY: 2,
  VENUE: 3,
  PRODUCTION: 4,
  COMPOSER: 5,
  DATE: 6,
  FESTIVAL: 7,
};

export const MEDIA_ATTRIBUTES_TYPES_IDS = {
  IMAGE_FORMAT: 1,
  WIDTH: 2,
  HEIGHT: 3,
  POSITION: 4,
  VIDEO_FORMAT: 5,
  DURATION: 6,
  GENRE: 7,
  TAGS: 8,
  AUDIO_FORMAT: 9,
  VIDEO: 11,
  IMAGE: 12,
  BANNER: 19,
};

export const VIDEO_ATTRIBUTE_SLUGS = {
  LIVESTREAM: 'live-stream',
  VIDEO_ON_DEMAND: 'on-demand',
};

export const VIDEO_ATTRIBUTE_TYPES_IDS = {
  START_DATE: 33,
  START_TIME: 34,
  END_DATE: 35,
  END_TIME: 36,
  TIMEZONE: 37,
  COST_TYPE: 41,
};

export const TAGS_AVAILABILITY_TYPES = {
  GALLERY: 'gallery',
  LABEL: 'label',
};

export const ARTIST_TAB_VALUES = {
  HOME: 'home',
  PERFORMANCES: 'performances',
  REPERTORIE: 'repertoire',
  BIO: 'bio',
  VIDEOS: 'videos',
  IMAGES: 'images',
  REVIEWS: 'reviews',
  CONTACT: 'contact',
  PHOTOS: 'photos',
};

export const CONTACT_TYPES = {
  BOX_OFFICE: 'box_office',
  COMPANY: 'company',
};

export const PRODUCTION_TAB_VALUES = {
  OVERVIEW: 'overview',
  PERFORMANCES: 'performances',
  CAST_AND_CREW: 'cast-and-crew',
  VIDEOS: 'videos',
  IMAGES: 'images',
  VENUES: 'venue',
  ABOUT: 'about',
};

export const COMPOSERS_TAB_VALUES = {
  HOME: 'home',
  WORKS: 'works',
  PERFORMANCES: 'performances',
  VIDEOS: 'videos',
  IMAGES: 'images',
  REVIEWS: 'reviews',
};

export const ROLE = 'role';
export const PROFESSION = 'profession';

export const emptySelectValue = { value: '', label: '' };

export const COMPANY_TAB_VALUES = {
  HOME: 'home',
  SEASONS: 'seasons',
  VIDEOS: 'videos',
  IMAGES: 'images',
  REVIEWS: 'reviews',
  CONTACT: 'contact',
  VENUES: 'venues',
  ABOUT: 'about',
};

export const PRODUCTION_DOCUMENT_TYPES = {
  SYNOPSIS: 'synopsis',
  BOOKLET: 'booklet',
  ACT: 'act',
  SYNOPSIS_ACT: 'synopsisAct',
  BOOKLET_ACT: 'bookletAct',
  SUPPORT_PRODUCTION_PAGE: 'supportProductionPage',
  SIGNED_CONTRACT: 'supportSignedContract',
  PRODUCTION_REVIEW: 'supportProductionReview',
  PRODUCTION_PROGRAMME: 'supportProductionProgramme',
};

export const MS_TO_DAY_DIVIDER = 86400000;
export const earliestYearOfMusicalWork = 1590;

export const MONTHS = [
  `${TP}.m_JANUARY`,
  `${TP}.m_FEBRUARY`,
  `${TP}.m_MARCH`,
  `${TP}.m_APRIL`,
  `${TP}.m_MAY`,
  `${TP}.m_JUNE`,
  `${TP}.m_JULY`,
  `${TP}.m_AUGUST`,
  `${TP}.m_SEPTEMBER`,
  `${TP}.m_OCTOBER`,
  `${TP}.m_NOVEMBER`,
  `${TP}.m_DECEMBER`,
];

export const FESTIVAL_TAB_VALUES = {
  HOME: 'home',
  PERFORMANCES: 'performances',
  VIDEOS: 'videos',
  IMAGES: 'images',
  REVIEWS: 'reviews',
  CONTACT: 'contact',
  VENUES: 'venues',
  ABOUT: 'about',
};

export const LOGO_TYPE = {
  CIRCLE: 1,
  SQUARE: 2,
  RECTANGLE: 3,
};

export const VENUE_TAB_VALUES = {
  HOME: 'home',
  PERFORMANCES: 'performances',
  VIDEOS: 'videos',
  IMAGES: 'images',
  REVIEWS: 'reviews',
  CONTACT: 'contact',
  ABOUT: 'about',
};

export const WORKS_TAB_VALUES = {
  HOME: 'home',
  PERFORMANCES: 'performances',
  VIDEOS: 'videos',
  IMAGES: 'images',
  REVIEWS: 'reviews',
  ABOUT: 'about',
};

export const PRODUCTION_VIEW_TYPES = {
  PERFORMANCE: 'performance',
  PRODUCTION: 'production',
};

export const EDIT_SEASON_MW_STEP = 1;
export const EDIT_SEASON_MEDIA_STEP = 4;
export const EDIT_ARTIST_MEDIA_STEP = 4;

export const FILE_TYPE = {
  PDF: 'application/pdf',
  PNG: 'image/png',
  JPEG: 'image/jpeg',
};

export const COMPLETED_PROFILE_SECTIONS_NAMES = {
  BASIC_INFORMATION: 'Basic Information',
  CONTACTS: 'Contact Information',
  DIGITAL_PRESENCE: 'Digital Presence',
  MANAGEMENT_STAFF: 'Management & Staff',
  VENUES: 'Venues',
  NAME: 'Name',
  PROFESSION: 'Profession',
  BIOGRAPHY: 'Biography',
  MEDIA: 'Images and Videos',
  IMAGES: 'Images',
  PUBLICATIONS: 'Reviews & Publications',
};

export const MEDIA_TABS = {
  SYNOPSIS: 'synopsis',
  IMAGES: 'images',
  VIDEO: 'video',
  VALIDATION: 'validation',
};

export const VALIDATION_STATUSES = {
  PENDING: 1,
  PROCESSING: 2,
  APPROVED: 3,
  REJECTED: 4,
};

export const defaultProductionPagination = { limit: 20, page: 1 };

export const PAGE_NAMES = {
  COMPANY: 'company',
  ARTIST: 'artist',
  FESTIVAL: 'festival',
  VENUES: 'venues',
  PRODUCTION: 'production',
};

export const VISIBILITY = {
  ALL: 'all',
};
